/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Raifragen } from '../../models/raifragen';

export interface ApiRaifragenIdGet$Json$Params {
  id: number;
}

export function apiRaifragenIdGet$Json(http: HttpClient, rootUrl: string, params: ApiRaifragenIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
  const rb = new RequestBuilder(rootUrl, apiRaifragenIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Raifragen>;
    })
  );
}

apiRaifragenIdGet$Json.PATH = '/api/Raifragen/{id}';
